
// Core packages
import { Component, OnDestroy, OnInit } from '@angular/core';

// Third party packages
import { Subscription } from 'rxjs';

// Custom packages
import { TranslationService } from 'src/app/shared/services/translation.service';
import { ValidationLoaderService } from 'src/app/shared/services/validations-loader.service';

// Language list
import enLang from 'src/assets/i18n/en.json';
import itLang from 'src/assets/i18n/it.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  /**
   * Class constructor
   */
  constructor(
    public translate: TranslationService,
    private validationLoaderService: ValidationLoaderService
  ) {
    // Translate services settings
    this.translate.loadTranslations(enLang, itLang);
  }

  /**
   * Init component
   *
   * @returns undefined
   */
  ngOnInit(): void {
    // Init formly validation messages loader
    // This will load validation messages globally
    this.validationLoaderService.init();
  }

  /**
   * Handle component destroy
   *
   * @returns undefined
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
